import replace from 'lodash/replace'
import findKey from 'lodash/findKey'
import get from 'lodash/get'
import { CONTENT_TYPE_VIDEO } from '../../../services/content/content-types'
import { getD6ContentType } from '../../../services/content/d6-content-types'
import {
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_LOGO,
  ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_9X16,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE,
  ASSET_CONTENT_REFERENCE_TYPE_TERM,
  ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW,
} from '../../../services/assets/content-reference-types'
import { FILE_LANGUAGES_MAP } from '../../../services/languages'

export const REGEX_FILE_NAME = /^([0-9]+)(\.([a-zA-Z]+))?/
export const TYPES = Object.freeze({
  [ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT]: /(\.person_headshot_image)/i,
  [ASSET_CONTENT_REFERENCE_TYPE_TERM]: /(\.person|\.tag)/i,
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE]: /_cvr$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT]: /4x3/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT]: /2x3/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT]: /(clean[-_]4k[-_]16x9|4k[-_]16x9[-_]clean)/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT]: /4k[-_]16x9/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT]: /(clean[-_]2k[-_]16x9|2k[-_]16x9[-_]clean)/i,
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT]: /2k[-_]16x9/i,
  [ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT]: /(1x1[-_]clean|clean[-_]1x1)/i,
  [ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT]: /1x1/i,
  [ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT]:
    /(Clean[-_]16x9|16x9[-_]clean|16x9[-_]clean[-_][0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT]: /(16x9|16x9_[0-9]+|16x9_bnr)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT]:
    /(hero-clean|hero-clean-[0-9]|hero_clean|hero_clean_[0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT]: /(hero|hero_[0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_LOGO]: /(logo|logo_[0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE]:
    /(person_headshot_circle|person_headshot_circle_source|person_headshot_circle_[0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4]: /(3x4|3x4-[0-9]|3x4_[0-9]+)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_9X16]: /(9x16|9[-_]16|poster[-_]9x16)$/i,
  [ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW]: /topics[-_]row/i,
})

const SLOT_FILENAME_TOKEN = Object.freeze({
  [ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT]: '16x9',
  [ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT]: '16x9_clean',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT]: '4k_16x9',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT]: '4k_16x9_clean',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT]: '2k_16x9',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT]: '2k_16x9_clean',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT]: '4x3',
  [ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT]: '2x3',
  [ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT]: '1x1',
  [ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT]: '1x1_clean',
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4]: '3x4',
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE]: 'cvr',
  [ASSET_CONTENT_REFERENCE_TYPE_POSTER_9X16]: '9x16',
})

const ASPECT_TOKEN_RE =
  /clean[-_]4k[-_]16x9|4k[-_]16x9[-_]clean|4k[-_]16x9|clean[-_]2k[-_]16x9|2k[-_]16x9[-_]clean|2k[-_]16x9|16x9[-_]clean|Clean[-_]16x9|16x9_bnr|16x9_[0-9]+|16x9|4x3|2x3|1x1[-_]clean|clean[-_]1x1|1x1|3x4|9x16|cvr/gi

function replaceLastAspectToken (base, token) {
  const re = new RegExp(ASPECT_TOKEN_RE.source, 'gi')
  let last = null
  let match = re.exec(base)
  while (match) {
    last = match
    match = re.exec(base)
  }
  if (!last) {
    return `${base}_${token}`
  }
  return `${base.slice(0, last.index)}${token}${base.slice(last.index + last[0].length)}`
}

/**
 * Rewrite a master filename so derived confirm rows match the target slot.
 */
export function originalFileNameForSlot (sourceName, targetType) {
  const token = SLOT_FILENAME_TOKEN[targetType]
  const name = String(sourceName || '')
  if (!token || !name) {
    return name
  }
  const lastDot = name.lastIndexOf('.')
  const base = lastDot > 0 ? name.slice(0, lastDot) : name
  const ext = lastDot > 0 ? name.slice(lastDot) : ''
  return `${replaceLastAspectToken(base, token)}${ext}`
}

// regex generated: /(en_US|fr_FR|es_LA|de_DE)/
export const LANGUAGES = new RegExp(`[-_](${Object.keys(FILE_LANGUAGES_MAP).join('|')})[-_]`)

export const getLanguageByName = (name) => {
  const matches = name.match(LANGUAGES)
  // console.log('Regex', LANGUAGES)
  // console.log('YEO', matches)
  const languageKey = get(matches, '[1]', '')

  return FILE_LANGUAGES_MAP[languageKey]
}

/**
 * Get the image content relationship type from the filename pattern
 * @param {String} name The filename
 * @returns {String} The content relationship type if a match is found
 */
export function getFileNameType (name) {
  const nameWoExt = replace(name, /\.[a-z]+$/i, '')
  return findKey(TYPES, (regex) => regex.test(nameWoExt))
}

/**
 * Get the d6 content id from a filename
 * @param {String} name The filename
 * @returns {Number} The d6 content id if found
 */
export function getFileNameD6Id (name) {
  const matches = REGEX_FILE_NAME.exec(name)
  return get(matches, '[1]')
}

/**
 * Get the d6 content type from a filename
 * @param {String} name The filename
 * @returns {String} The d6 content type if found or 'video' if not
 */
export function getFileNameD6ContentType (name) {
  const matches = REGEX_FILE_NAME.exec(name)
  const contentType = get(matches, '[3]') || CONTENT_TYPE_VIDEO
  return getD6ContentType(contentType)
}
